import { styled } from '@mui/system'
import Typography from '@/ui/components/typography'
import { LinkButton } from '@/ui/components/buttons/link'
import { TTheme } from '@/core/theme'

export const IntegrationsTitle = styled(Typography)`
    margin-bottom: 12px;
`
export const IntegrationsDescription = styled(Typography)`
    margin-bottom: 24px;
`

export const IntegrationsContainer = styled('div')`
    margin-bottom: calc(var(--footer-h));
`
export const DescriptionWrapper = styled('div')`
    display: flex;
    gap: 4px;
`

export const InfoBannerWrapper = styled('div')`
    margin-bottom: 24px;
`

export const LinkButtonWrapper = styled(LinkButton)<{ theme?: TTheme }>`
    &:hover {
        color: ${({ theme }: { theme: TTheme }) =>
            theme.colors.semantic.activationButtonHover};
`
